<fuse-alert appearance="outline" class="max-w-2xl" dismissible="false" type="basic">
  <span fuseAlertIcon>
    <mat-icon>warning</mat-icon>
  </span>
  <span fuseAlertTitle>{{ "PASSWORD_POLICY_DESCRIPTION_TITLE" | translate }}</span>
  <span> {{ "PASSWORD_POLICY_DESCRIPTION" | translate }} {{ "ERROR_PASSWORD_RECENTLY_USED" | translate }} </span>
</fuse-alert>
